// https://vuex.vuejs.org/en/actions.html

import NewApiService from "@/utils/new.api.service";

export default {
  list(context,params) {
    context.commit("set_loading");
    const {pagination, search, filters, expand} = params

    var filter = [];
    Object.keys(filters).forEach((key) => {
        filter[key] = filters[key]
    });

    let sort = pagination.sortBy[0];

    if(pagination.sortDesc[0] == false){
      sort = '-'+sort;
    }
    let page = pagination.page
    let rows_per_page = pagination.itemsPerPage


    return new Promise(resolve => {
      NewApiService.get("admin/handling", {
        sort, page, search, filter, expand, rows_per_page
      })
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  get(context, buildId){
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.get("admin/handling/"+buildId)
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },

  
  completeBuild(context, buildId){
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.post("admin/handling/"+buildId+"/complete-build")
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },

  markAsShipping(context, {id}) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.put("admin/handling/"+id+"/mark-as-shipping")
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response)
        })
        .finally(() => {
          context.commit("unset_loading");
        })
    });
  },
  markAsShipped(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.put("admin/handling/"+params.id+"/mark-as-shipped", {
        trackingId: params.trackingId,
        comment: params.comment
      })
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  assignToCart(context, params){
    const {buildId, cartId, items} = params
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.put("admin/handling/"+buildId+"/assign-to-cart",{cartId, items})
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data.build);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  changeStatus(context, params){
    context.commit("set_loading");
    const {status_id} = params;
    return new Promise(resolve => {
      NewApiService.put("admin/handling/"+params.id,{status_id})
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },

  markAllProductsAsBuilt({commit}, handlingId) {
    commit("set_loading");
    return new Promise((resolve) => {
      NewApiService.put("admin/handling/"+handlingId+"/mark-all-products-as-built")
        .then(({data}) => {
          commit("unset_loading");
          resolve(data);
        })
    })
  },

  markProductAsBuilt({ commit }, params){
    commit("set_loading");
    const { id, quantityToMarkAsBuilt } = params
    return new Promise((resolve) => {
      NewApiService.put("admin/handling/mark-product-as-built", {id, quantityToMarkAsBuilt})
        .then(({data}) => {
          commit("unset_loading");
          resolve(data);
        })
    })
  },

  markProductAsNotBuilt({ commit }, params){
    commit("set_loading");
    const { id, quantityToMarkAsNotBuilt } = params
    return new Promise((resolve) => {
      NewApiService.put("admin/handling/mark-product-as-not-built", {id, quantityToMarkAsNotBuilt})
        .then(({data}) => {
          commit("unset_loading");
          resolve(data);
        })
    })
  },

  returnProductToPendingBox({ commit }, params){
    commit("set_loading");
    const { id, quantityToReturn } = params
    return new Promise((resolve) => {
      NewApiService.put("admin/handling/return-product-to-pending-box", {id, quantityToReturn})
        .then(({data}) => {
          commit("unset_loading");
          resolve(data);
        })
    })
  },
  
  transferProductFromPendingBox({ commit }, params){
    commit("set_loading");
    const { handlingId, products } = params
    return new Promise((resolve) => {
      NewApiService.put("admin/handling/"+handlingId+"/transfer-product-from-pending-box", {products})
        .then(({data}) => {
          commit("unset_loading");
          resolve(data);
        })
    })
  },
  download(context, { id }) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.get(`admin/handling/${id}/download`)
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
};
